import { useLang } from "@/context/LanguageContext";
import { LANGS } from "@/lib/i18n";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const LanguageSwitcher = ({ className = "", idSuffix = "" }) => {
  const { lang, setLang } = useLang();
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={`language-switcher${idSuffix}`}
          className={`flex items-center gap-1.5 rounded-sm border border-neutral-200 px-2.5 py-1.5 text-xs font-semibold uppercase tracking-wide text-neutral-600 transition-colors hover:border-black hover:text-black ${className}`}
        >
          <Globe className="h-3.5 w-3.5" /> {current.short}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[9rem]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}${idSuffix}`}
            onClick={() => setLang(l.code)}
            className={l.code === lang ? "font-semibold" : ""}
          >
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
